import React, { Component } from "react"
import { Grid, Row, Col } from "react-bootstrap"
import Sidebar from "../components/Sidebar.js"
import { sendEmail } from "../helpers/api.js"
import { Seo } from "../components/Seo.js"

class Contacts extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showMessage: false,
      shakeTextbox: false,
      email: "",
      message: ""
    }
  }

  render() {
    return (
      <section className = { "contacts-page" }>
        <Seo title="Contacts"></Seo>
        <Grid fluid>
          <Row>
            <Col md = { 1 }>
              <Sidebar />
            </Col>
            <Col md = { 11 }>
              <Row>
                <Col md = { 12 }>
                  <h1>+39 . 348 . 984 . 8960</h1>
                  <h2><a href = { "mailto:giacomobrunoph@gmail.com" }>giacomobrunoph@gmail.com</a></h2>
                </Col>
              </Row>
              <Row>
                <Col sm = { 1 } />
                <Col sm = { 5 }>
                  <section className = { "represented-by" }>
                    Represented by<br />
                    DocArtist - <strong>Milano</strong>
                  </section>
                  <section className = { "commercial-portfolio" }>
                    {
                      this.state.showMessage ? (
                        <strong>{ this.state.message }</strong>
                      ) : (
                        <form
                          action = { "#" }
                          onSubmit = { event => {
                            event.preventDefault()
                            const { email } = this.state
                            if (email) {
                              sendEmail(email)
                                .then(({ ResponseMetadata }) => this.setState({
                                  showMessage: true,
                                  message: ResponseMetadata ? "Thank you!" : "Something went wrong, try later"
                                }))
                            } else {
                              this.setState({
                                shakeTextbox: true
                              })
                            }
                          }}
                        >
                          <input
                            type = { "text" }
                            className = { this.state.shakeTextbox ? "shake" : "" }
                            placeholder = { "Type your email here" }
                            onChange = { element => {
                              const { target: { value: email } } = element
                              this.setState({ email })
                            }}
                            onAnimationEnd = { () => this.setState({ shakeTextbox: false }) }
                          />
                          <br/>
                          <input type = { "submit" } value = { "Request commercial portfolio" }/>
                        </form>
                      )
                    }
                  </section>
                </Col>
              </Row>
            </Col>
          </Row>
        </Grid>
      </section>
    )
  }
}

export default Contacts



// WEBPACK FOOTER //
// ./src/containers/Contacts.js